
import Grid from "@mui/material/Grid";
import Lottie from "lottie-react";

import { useAppSelector } from "../../app/store/hooks";
import useRatingsForRecipes from "../../hooks/useRatingsForRecipes";
import recipeLoadingAnimation from "../../lottie/recipeLoader.json";
import RecipeCard from "../recipeCard";
import { TextPrimary, TextPrimaryBold } from "../typography";
import styles from "./searchRecipe.module.css"

const LoaderView = () => {
	const searchQueryLoading = useAppSelector(state => state.search.searchQueryLoading);
	const searchPageFilteredRecipes = useAppSelector((state) => state.search.searchFilteredRecipes);
	if (searchQueryLoading && searchPageFilteredRecipes.length === 0) {
		return (
			<div className={styles.loader}>
				<Lottie animationData={recipeLoadingAnimation} className={styles.loader_lottie} loop />
			</div>
		);
	}
	if (searchPageFilteredRecipes.length !== 0) {
		return <Grid className={styles.text}><TextPrimaryBold color='#000' text='All Recipes' /></Grid>;
	}
	if (!searchQueryLoading && searchPageFilteredRecipes.length === 0) {
		return <Grid className={styles.text}><TextPrimary color='#000' text='No results found' /></Grid>;
	}
	return null;
};

const AllRecipeSection = () => {
	const searchPageFilteredRecipes = useAppSelector(state => state.search.searchFilteredRecipes);
	const { recipesWithRatings, loading: fetchingRatings } = useRatingsForRecipes(searchPageFilteredRecipes);

	if (recipesWithRatings.length === 0 && fetchingRatings) {
		return <LoaderView />;
	}

	return (
		<Grid>
			<Grid container><LoaderView /></Grid>
			<Grid className={styles.search_recipes}>
				{recipesWithRatings?.map((recipe) => (
					<RecipeCard
						key={recipe?.id}
						recipe={recipe}
						source="explore"
					/>
				))}
			</Grid>
		</Grid>
	);
};

export default AllRecipeSection;